// Pure view-model helpers for the admin acquisition-proof panel. Keep all
// truthfulness rules here (never call zero engagement "healthy"; honest empty
// state when has_data=false) so they are unit-testable without the DOM.

export function windowDays(w) { return w === "30d" ? 30 : 7; }

export function metricsHasData(m) { return !!(m && m.has_data === true); }

export function pct(n) { return `${Math.round((Number(n) || 0) * 100)}%`; }

export function fmtDurationMs(ms) {
  if (ms == null || !Number.isFinite(Number(ms))) return "—";
  const s = Math.round(Number(ms) / 1000);
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return m > 0 ? `${m}m ${rem}s` : `${rem}s`;
}

// Honest empty-state copy. Zero engagement is NEVER framed as traction/health.
export function emptyStateCopy(m) {
  return (m && m.note) || "No first-party telemetry recorded in this window yet. These figures are zero because no real events exist — nothing is seeded or estimated.";
}

// Operations readiness → uniform rows { key, label, ok, detail }. A validated
// show requires strategy_version >= 4 AND ok; ready audio requires >0 lines.
export function readinessChecks(r) {
  if (!r) return [];
  const feed = r.current_season_feed || {};
  const cards = r.featured_prediction_cards || {};
  const show = r.character_show || {};
  const pv = r.providers || {};
  const validShow = !!show.ok && Number(show.strategy_version) >= 4;
  const audioLines = Number(show.ready_audio_lines) || 0;
  return [
    { key: "feed", label: "Current-season feed", ok: !!feed.ok, detail: feed.ok ? `${feed.count} games · ${feed.season}${feed.live_serving ? " · live" : ""}` : (feed.reason || "unavailable") },
    { key: "cards", label: "Featured demo cards", ok: !!cards.ok, detail: cards.ok ? `${cards.count} cards · ${cards.game_id || ""}` : (cards.reason || "unavailable") },
    { key: "show", label: "Validated v4+ show", ok: validShow, detail: validShow ? `v${show.strategy_version} · ${show.published ? "published" : "unpublished"}` : (show.reason || `v${show.strategy_version ?? "?"} not valid`) },
    { key: "audio", label: "Ready audio lines", ok: audioLines > 0, detail: `${audioLines} line${audioLines === 1 ? "" : "s"} · ${show.audio_state || "unknown"}` },
    { key: "providers", label: "Provider / kill-switch", ok: !!pv.ok, detail: `${pv.sports_provider || "?"} · character kill ${pv.character_global_kill ? "ON" : "off"} · audio kill ${pv.audio_provider_kill ? "ON" : "off"}` },
    { key: "revision", label: "Backend revision", ok: !!r.backend_revision, detail: r.backend_revision || "unknown" },
  ];
}

export function readinessOverallOk(r) {
  if (!r) return false;
  if (typeof r.overall_ok === "boolean") return r.overall_ok;
  return readinessChecks(r).every((c) => c.ok);
}
